import { currencyNoSymbolNoNA } from 'util/format';
import { pick, evolve } from 'ramda';

const transformations = {
  bpConfig: {
    bpExpediteFeeAmount: currencyNoSymbolNoNA(),
  },
  p2pConfig: {
    p2pRealtimeFeeAmount: currencyNoSymbolNoNA(),
  },
};

// eslint-disable-next-line import/prefer-default-export
export const transform = (
  fspConfig,
  fspConfigKey,
  fspConfigInitValues,
  keys
) => {
  const initConfig = fspConfigInitValues
    ? fspConfigInitValues(fspConfig)
    : keys && !fspConfigKey
    ? pick(keys, fspConfig)
    : fspConfig;
  if (!fspConfig) return initConfig;
  return evolve(transformations, initConfig);
};
